import apiService from '@/services/apiService';

const actions = {
  getJobvacancy({ commit }) {
    apiService.setHeader();
    apiService.get('px/job-vacancy')
      .then((response) => {
        commit('getJobvacancy', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getJobvacancyid({ commit }, payload) {
    apiService.get(`px/job-vacancy/${payload}`)
      .then((response) => {
        commit('getJobvacancyid', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getJobtype({ commit }) {
    apiService.setHeader();
    apiService.get('job-type')
      .then((response) => {
        commit('getJobtype', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getJobexperience({ commit }) {
    apiService.setHeader();
    apiService.get('job-experience')
      .then((response) => {
        commit('getJobexperience', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postJobvacancy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('px/job-vacancy', payload)
        .then((response) => {
          commit('postJobvacancy', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putJobvacancy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`px/job-vacancy/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putJobvacancy', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delJobvacancy({ commit }, payload) {
    apiService.delete(`px/job-vacancy/${payload}`)
      .then((response) => {
        commit('delJobvacancy', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;
